import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class INDRATranslationToggleService {
  getValue(): boolean {
    return !!JSON.parse(localStorage.getItem("disableTranslation"));
  }

  setValue(value: boolean): void {
    localStorage.setItem("disableTranslation", JSON.stringify(value));
  }
}
